import React, { Component } from 'react';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';
import Hidden from 'material-ui/Hidden';

import getImage from '../imageService';

import Subdevice from "./Subdevice";

class Device extends Component {
  render() {
    const device = this.findDevice(this.props.match.params.device);

    if (!device) return null;

    const image = getImage(device.id);
    return (
      <Grid container spacing={24} justify='center' className='device'>
        <Grid item align='center' xs={10}>
          <Grid item>
            <Hidden mdDown>
              <Typography component="h3" align="center" variant="display3" className="landingHeading">
                { device.name }
              </Typography>
            </Hidden>
            <Hidden only={['xs', 'lg', 'xl']}>
              <Typography component="h3" align="center" variant="display2" className="landingHeading">
                { device.name }
              </Typography>
            </Hidden>
            <Hidden smUp>
              <Typography component="h3" align="center" variant="headline" className="landingHeading">
                { device.name }
              </Typography>
            </Hidden>
          </Grid>
          <Grid itemalign="center">
            <img src={image} alt={device.name} />
          </Grid>
          <Grid item>
            <Typography variant="body1" gutterBottom align="justify">
              { device.description }
            </Typography>
            { device.subdevices &&
              device.subdevices.map(subdevice => (
                <Subdevice device={ subdevice } />
              ))
            }
          </Grid>
        </Grid>
      </Grid>
    )
  }

  findDevice = id => {
    const devices = this.props.devices;

    return devices.find(device => device.id === id);
  }
}

export default Device;



// WEBPACK FOOTER //
// ./src/components/Device.js